module.exports = __webpack_public_path__ + "img/down.dd3ceab0.svg";